<template>
  <v-app id="app">
    <div app-data="true">
        <div>
            <router-view v-if="isAllUIConfigurationsLoaded"></router-view>
            <div v-else>App Loading....</div>
        </div>
    </div>
  </v-app>
</template>

<script>
// import LoaderComponent from '@/components/LoaderComponent'
// import { mapActions } from 'vuex'
import { mapActions, mapGetters } from 'vuex'
import { store } from './store'
export default {
  name: 'app',
  components: {
  },
  data () {
    return {
      isAllUIConfigurationsLoaded: false,
    }
  },
  async mounted() {
    try {
      await this.loadAaPlugin();
    } catch(error) {
      console.log(error, "Error in mounted method of App.vue")
    }
    this.loadUiConfigs(); // Loading UI Configurations first and once loaded then we are enabling the router-view based on isAllUIConfigurationsLoaded boolean.
    window.onpopstate = event => {
      console.log(event)
      if (window.location.pathname == "/"+iamvar_uiContext+"/business/login/stepup") {
        history.back()
        /* if(store.state.cvsstepup.flowType === 'forgot_password') {
          history.back()
        } else if (store.state.cvsstepup.flowType === 'forgot_username') {
          history.back()
        } else if(store.state.cvsstepup.flowType === 'auth') {
          // var mountUrl = store.state.login.urlOnMount
          // window.location.href = mountUrl
          history.back()
        }*/

        
        // history.back()
        /* var mountUrl = store.state.login.urlOnMount
        if(mountUrl.includes("appview=odi")) // odi
          this.$router.push({ name: 'ODILoginComponent', query: { goto: store.state.login.gotoUrl }})
        else if(mountUrl.includes('mainlogin')) //mainlogin
          window.location.href = mountUrl
        else //simplelogin
          this.$router.push({ name: 'SimpleLoginRoot', query: { goto: store.state.login.gotoUrl }}) */// redirect to home, for example
      }
    };

    // Providing access to VpsProfile screen for both vps user and vps wholesale user.
    if (window.location.pathname == "/account/business/login/vpsprofile") {
      if(this.$route.query.env === "SIT" || this.$route.query.env === "UAT") {
        if (this.$route.query.client_Id == "VPS") {
            this.updateVpsClientId(this.$route.query.client_Id)
            this.udpateVpsCapturedEnv(this.$route.query.env)
            this.$router.push({ name: 'VPSSecurityProfilePage' })
        } else if (this.$route.query.client_Id === "VPSWholeSale") {
            this.updateVpsWholeSaleClientId(this.$route.query.client_Id)
            this.udpateVpsWholeSaleCapturedEnv(this.$route.query.env)
            this.$router.push({ name: 'VPSSecurityProfilePage' })
        }
      } else {
        if (this.$route.query.client_Id == "VPS") {
            this.updateVpsClientId(this.$route.query.client_Id)
            this.udpateVpsCapturedEnv("PROD")
            this.$router.push({ name: 'VPSSecurityProfilePage' })
        } else if (this.$route.query.client_Id === "VPSWholeSale") {
            this.updateVpsWholeSaleClientId(this.$route.query.client_Id)
            this.udpateVpsWholeSaleCapturedEnv("PROD")
            this.$router.push({ name: 'VPSSecurityProfilePage' })
        }
      }
    }
    
  },
  methods: {
    ...mapActions('profile', [
      'udpateVpsCapturedEnv',
      'updateVpsClientId',
      'udpateVpsWholeSaleCapturedEnv',
      'updateVpsWholeSaleClientId'

    ]),

    loadUiConfigs() {
      const envtt = window.location.protocol + '//' + window.location.hostname + '/account/uiconfigs'
      fetch(envtt).then((responseUiConfig) => {
        this.isAllUIConfigurationsLoaded = true;
        let features = responseUiConfig?.headers?.get('featureflag')
        let featuresArray = features.split('|')
        if (featuresArray && featuresArray.includes('jcaptcha')) {
          iamvar_enableJCaptcha = true
        } else {
          iamvar_enableJCaptcha = false
        }
        if (featuresArray && featuresArray.includes('iamvar_push_newdesign')) {
          iamvar_push_newdesign = true
        } else {
          iamvar_push_newdesign = false
        }
        if (featuresArray && featuresArray.includes('gcaptchav3')) {
          iamvar_enable_recaptchaV3_ForgotFlows = true
        } else {
          iamvar_enable_recaptchaV3_ForgotFlows = false
        }
      }).catch((error) => {
        console.log(error, "UI configs API Error")
        // Loading default configurations incase of configs API failure.
        this.isAllUIConfigurationsLoaded = true;
      })
    },
    loadAaPlugin() {
      return new Promise((resolve, reject) => {
        const script = document.createElement('script')
        script.src = vzigaaPluginScript
        // script.async = true
        script.onload = () => {
            resolve()
        }
        script.onerror = () => {
          reject(new Error('Failed to load the script'))
        }
        document.head.appendChild(script)
      }).then(() => {
        console.log('Script loaded successfully')
      }).catch((error) => {
        console.error(error)
      })
    }
  },
  computed: {
      ...mapGetters('login', [
      'gotoUrl',
      'urlOnMount'
    ])
  }
}
</script>

<style>

.v-application .error {
  background-color: #ed7000 !important; 
  border-color: #ed7000 !important;
}
.v-application .info {
  background-color: #08c !important; 
  border-color: #08c !important;
}

.v-application .success {
  background-color: #00ac3e !important; 
  border-color: #00ac3e !important;
}
</style>
